<template>

  <v-row>
    <v-col
      cols="12"
      md="3"
    >
      <v-select
        :items="makes"
        label="Make *"
        outlined
        v-model="car.make"
        :rules="[rules.required]"
        required
        item-text="name"
        :disabled="disabled"
        :hide-details="disabled"
      ></v-select>
    </v-col>

    <v-col
      cols="12"
      md="3"
    >
      <v-select
        :items="models"
        label="Model *"
        outlined
        v-model="car.model"
        :rules="[rules.required]"
        required
        item-text="name"
        :disabled="disabled"
        :hide-details="disabled"
      ></v-select>
    </v-col>

    <v-col
      cols="12"
      md="3"
    >
      <v-text-field
        v-model="car.year"
        :rules="[rules.required]"
        label="Year *"
        required
        type="tel"
        outlined
        :disabled="disabled"
        :hide-details="disabled"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="3"
    >
      <v-row no-gutters class="flex-nowrap">
        <v-text-field
          v-model="car.vin"
          :rules="[rules.required]"
          label="Vin *"
          required
          outlined
          :disabled="disabled"
          :hide-details="disabled"
        ></v-text-field>
        <v-btn v-if="!disabled" class="mt-2 ml-2" icon color="warning" @click="remove(i)"><v-icon>delete</v-icon></v-btn>
      </v-row>
    </v-col>
  </v-row>

</template>

<script>
import makes from "./makes.json"
import models from "./models.json"

export default {
  name: "CustomerCar",
  props: ['car', 'rules', 'remove', "i", "disabled"],
  data: () => ({
    makes,
    models: []
  }),
  watch: {
    car: {
      handler (val) {
        const makerModels = models[val.make];
        if(makerModels) {
          this.models = makerModels;
        } else {
          this.models = [];
        }
      },
      deep: true,
    }
  },
  mounted() {
    if(this.car && this.car.make) {
      const makerModels = models[this.car.make];
      if(makerModels) {
        this.models = makerModels;
      } else {
        this.models = [];
      }
    }
  }
};
</script>